import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect'

import { routerActions } from 'connected-react-router'

import routes from '../../constants/routes'

import { isAuthenticated, hasIncompleteProfile} from '../../auth/selectors'

const userMustCompleteProfile = connectedReduxRedirect({
  redirectPath: state => {
    if (isAuthenticated(state)) {
      return routes.COMPLETE_PROFILE
    }
    return routes.LOGIN
  },
  authenticatedSelector: state => {
    return isAuthenticated(state) && !hasIncompleteProfile(state);
  },
  redirectAction: routerActions.replace,
  allowRedirectBack: false,
  wrapperDisplayName: 'MustCompleteProfile'
})

export default userMustCompleteProfile
